import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FeescategoryserviceService {

  constructor(private http: HttpClient, private global: Globle) { }

  getAllCategory() {
    return this.http.get<[]>(this.global.APIURLV2 + "efcategoryprices/getallcategory");
  }

  getByCategory(categoryId: number) {
    return this.http.get<[]>(this.global.APIURLV2 + "efcategoryprices/getbycategory/" + categoryId);
  }

  CreateCategory(obj: any) {
    return this.http.post(this.global.APIURLV2 + "efcategoryprices/createcategory", obj)
  }

  UpdateCategory(obj: any) {
    return this.http.put(this.global.APIURLV2 + "efcategoryprices/updatecategory", obj)
  }

  saveCategoryPrices(obj: any) {
    return this.http.post<any>(this.global.APIURLV2 + "efcategoryprices/savefees", obj)
  }
}
